import { render, staticRenderFns } from "./CustomerInfo.htm?vue&type=template&id=21a7e58e&scoped=true&"
import script from "./CustomerInfo.ts?vue&type=script&lang=js&"
export * from "./CustomerInfo.ts?vue&type=script&lang=js&"
import style0 from "./CustomerInfo.scss?vue&type=style&index=0&id=21a7e58e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21a7e58e",
  null
  
)

export default component.exports